import React from 'react';

type Provider = 'google' | 'microsoft';

type Props = {
  provider: Provider;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
};

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <path
      d="M17.64 9.204c0-.638-.057-1.252-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.716v2.258h2.908c1.703-1.567 2.684-3.873 2.684-6.615z"
      fill="#4285F4"
    />
    <path
      d="M9 18c2.43 0 4.468-.805 5.957-2.18l-2.908-2.258c-.806.54-1.838.86-3.049.86-2.344 0-4.33-1.582-5.036-3.71H.957v2.332C2.438 15.983 5.481 18 9 18z"
      fill="#34A853"
    />
    <path
      d="M3.964 10.712A5.39 5.39 0 0 1 3.68 9c0-.594.102-1.17.284-1.712V4.956H.957A8.998 8.998 0 0 0 0 9c0 1.446.346 2.812.957 4.044l3.007-2.332z"
      fill="#FBBC05"
    />
    <path
      d="M9 3.579c1.321 0 2.507.455 3.441 1.349l2.582-2.582C13.463.891 11.425 0 9 0 5.481 0 2.438 2.017.957 4.956l3.007 2.332C4.67 5.161 6.656 3.579 9 3.579z"
      fill="#EA4335"
    />
  </svg>
);

const MicrosoftIcon = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <rect width="9" height="9" x="1" y="1" fill="#f25022" />
    <rect width="9" height="9" x="10" y="1" fill="#7fba00" />
    <rect width="9" height="9" x="1" y="10" fill="#00a4ef" />
    <rect width="9" height="9" x="10" y="10" fill="#ffb900" />
  </svg>
);

export const SocialLoginButton: React.FC<Props> = ({ provider, label, onClick, disabled, loading }) => {
  const Icon = provider === 'google' ? GoogleIcon : MicrosoftIcon;
  const buttonLabel = loading ? 'Connecting...' : label;
  const providerClass = `social-login-button ${provider}`;

  return (
    <button type="button" className={providerClass} onClick={onClick} disabled={disabled || loading}>
      <span className="icon">
        <Icon />
      </span>
      <span className="label">{buttonLabel}</span>
    </button>
  );
};
